import React, { useContext } from 'react';
import CustomCard from '../../../../Util/CustomCard';
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import styles from "../ServiceRequestDetails.module.css";
import AuthContext from '../../../../../store/auth-context';
import { GlobalContext } from '../../../../../store/global-context';
import axios from 'axios';
import { ServiceRequestContext } from '../../../../../store/service-request';
import { errorMessage } from "../../../../Util/errorMessage";

// Q34 (ticket 21): the Supporting Document's file name downloads it. v1.2 drew it as a <span onClick>: no Tab stop, no
// role, no name, so only a mouse could fetch it. Now a native button with v1.2's link look (ServiceRequestDetails.module
// .css), named "Download <file name>": the name contains the visible file name, so voice control still matches it
// (2.5.3). With no document, "N/A" stays plain text. One component for both layouts (investor, Operations).
// Ticket 18 (Q35, found by the final seam-2 busy walk): while its download runs (`busy`, kept by ServiceRequestDetails)
// the button says it is busy and ignores presses (v1.3 before: a second Return sent a second request). Same states as
// Util/busyButton.js, written out here because that helper's props are PrimeReact Button props; a native button is never
// disabled, so focus stays on it.
const SupportingDocument = ({ request, downloadFile, busy }) => {
  if (!request.supporting_document) return <span>N/A</span>;
  const name = request.supporting_document_name;
  return (
    <button type="button" className={styles['download-supporting-doc']} aria-label={`Download ${name}`}
      aria-disabled={busy ? "true" : undefined} aria-busy={busy ? "true" : undefined}
      onClick={() => { if (!busy) downloadFile("", request.supporting_document, name); }}>
      {name}
    </button>
  );
};

const RequestDetails = (props) => {
    const authCtx = useContext(AuthContext);
    const globalCtx = useContext(GlobalContext);
    const serviceCtx = useContext(ServiceRequestContext);
    const updateStatus = (val,request_id) => {
        axios
        .post("/api/user/update-service-status", {status:val,request_id:request_id} , {
          headers: {Authorization: "Bearer " + authCtx.authTokens.access },
        })
        .then((res) => {
          props.setSelectedRequest(res.data.obj);
          serviceCtx.setListOfServiceRequests(prevState => prevState.map((item) => item.request_id === res.data.obj.request_id ? res.data.obj : item));
          globalCtx.raiseAlert("Status updated!","success");
        //   closeModalHandler();
        })
        .catch((e) => {
            globalCtx.raiseAlert(errorMessage(e), "error");
        });
    }

  return (
    <CustomCard styles={{flex:"1",display:"flex",flexDirection:"column"}}>
        {/* RCMC-08 (ticket 21): the card's title is a heading (it looks like one), with v1.2's look */}
        <h2 className={styles['card-title']} style={{padding:"10px",fontWeight:"bold",borderBottom:"1px solid #ddd"}}>Request Details</h2>
        <div style={{padding:"10px",flex:"1",display:"flex",flexDirection:"column",justifyContent:"space-between"}}>
            {authCtx.user.is_admin?<div className={styles['details-row']}>
                <div className={styles['details-container']}>
                    <span className={styles['header']}>Created On</span>
                    <span title={props.selectedRequest.created_on}>{props.selectedRequest.created_on}</span>
                </div>
                <div className={styles['details-container']}>
                    <span className={styles['header']}>Company Name</span>
                    <span title={props.selectedRequest.company_name}>{props.selectedRequest.company_name}</span>
                </div>
            </div>:<><div className={styles['details-container']}>
                    <span className={styles['header']}>Created On</span>
                    <span title={props.selectedRequest.created_on}>{props.selectedRequest.created_on}</span>
                </div>
                <div className={styles['details-container']}>
                    <span className={styles['header']}>Company Name</span>
                    <span title={props.selectedRequest.company_name}>{props.selectedRequest.company_name}</span>
                </div></>}
            {authCtx.user.is_admin ? <div className={styles['details-row']}>
                <div className={styles['details-container']}>
                    <span className={styles['header']}>Folio No / DP-Client ID</span>
                    <span title={props.selectedRequest.folio_no}>{props.selectedRequest.folio_no}</span>
                </div>
                <div className={styles['details-container']}>
                    <span className={styles['header']}>Supporting Document</span>
                    <SupportingDocument request={props.selectedRequest} downloadFile={props.downloadFile} busy={props.isDownloading("")} />
                </div>
            </div>:<><div className={styles['details-container']}>
                    <span className={styles['header']}>Folio No / DP-Client ID</span>
                    <span title={props.selectedRequest.folio_no}>{props.selectedRequest.folio_no}</span>
                </div>
                <div className={styles['details-container']}>
                    <span className={styles['header']}>Supporting Document</span>
                    <SupportingDocument request={props.selectedRequest} downloadFile={props.downloadFile} busy={props.isDownloading("")} />
                </div></>}
            <div className={styles['details-container']}>
                <span className={styles['header']}>Request Type</span>
                <span title={props.selectedRequest.request_type}>{props.selectedRequest.request_type}</span>
            </div>
            <div className={styles['details-container']}>
                <span className={styles['header']}>Description</span>
                <span title={props.selectedRequest.description}>{props.selectedRequest.description}</span>
            </div>
            <div className={styles['details-container']}>
                <span className={styles['header']}>Status</span>
                {!authCtx.user.is_admin ? <span>{props.selectedRequest.status_display}</span> :
                <div style={{display:"flex",alignItems:"center"}}>
                    <Dropdown optionValue="value" optionLabel="label" value={props.currentStatus} onChange={(e) => {props.setCurrentStatus(e.value);}} options={serviceCtx.listOfStages} placeholder="Status" className="w-full md:w-14rem" style={{flex:"1"}} />
                    <Button onClick={() => {updateStatus(props.currentStatus,props.selectedRequest.request_id)}} raised className='status-button' icon="pi pi-check" style={{background:"var(--portal-primary)",color:"var(--portal-on-primary)",marginLeft:"10px",border:"none"}}/>
                </div>}
            </div>
        </div>
        {/* <div className={styles['details-column']} style={{flex:"1"}}>
            
            
            
        </div> */}
    </CustomCard>
  )
}

export default RequestDetails
